export const expand = (index, expanders, setExpander, autoAdjust) => {
  const elementToOpen = document.getElementById(`header_${index}`);
  const currentExpanders = expanders;
  const newExpanders = {};
  newExpanders[index] = !currentExpanders[index];
  setExpander({ ...currentExpanders, ...newExpanders });

  // If another header is already expanded, and user is expanding a different one
  if (
    autoAdjust &&
    Object.values(currentExpanders).some(val => val === true) &&
    !currentExpanders[index]
  ) {
    setTimeout(function() {
      elementToOpen.scrollIntoView(true);
    }, 1);
  }
};
